"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOrganizationFacingComponentsMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
/**
 * Context for the organization-facing components showcase template. Org-facing emails carry Zeffy's
 * own fixed branding (not the org's brand color), so the theme is constant and light-only.
 */
const buildOrganizationFacingComponentsMockData = ({ locale = "en", subject = "Zeffy — organization email components", formUrl = "https://www.zeffy.com/en-US/ticketing/spring-gala-2026", viewInBrowserUrl = "https://www.zeffy.com/email/preview", } = {}) => {
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme: (0, email_theme_tokens_1.getOrgFacingEmailTheme)(),
        currentYear: new Date().getFullYear(),
        lang: locale,
        subject,
        isPreview: false,
        formUrl,
        viewInBrowserUrl,
        appStoreUrl: "https://apps.apple.com/us/app/zeffy-tap-to-pay/id1668842941",
        playStoreUrl: "https://play.google.com/store/apps/details?id=com.zeffy.taptopay",
    };
};
exports.buildOrganizationFacingComponentsMockData = buildOrganizationFacingComponentsMockData;
